import { render, staticRenderFns } from "./wx.vue?vue&type=template&id=f3a8c982"
import script from "./wx.vue?vue&type=script&lang=js"
export * from "./wx.vue?vue&type=script&lang=js"
import style0 from "./wx.vue?vue&type=style&index=0&id=f3a8c982&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports